/**
 * 专家相关接口
 */
import http, { BASE_NAME } from './index.js';

/**
 * 获取专家列表
 */
export async function getExpertList(params) {
  try {
    const data = await http.get(`${BASE_NAME}/expert/homepage`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得TOP1的专家
 */
export async function getExpertTop1(params) {
  try {
    const data = await http.get(`${BASE_NAME}/expert/top`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 创建专家
 */
export async function createExpert(value) {
  try {
    const data = await http.post(`${BASE_NAME}/expert/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 更新专家
 */
export async function updateExpert(value) {
  try {
    const data = await http.put(`${BASE_NAME}/expert/update`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得专家
 */
export async function expertInfo(params) {
  try {
    const data = await http.get(`${BASE_NAME}/expert/get`, { params });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 创建专家成果
 */
export async function createExpertAchievement(value) {
  try {
    const data = await http.post(`${BASE_NAME}/expert/achievement/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 更新专家成果
 */
export async function updataExpertAchievement(value) {
  try {
    const data = await http.put(`${BASE_NAME}/expert/achievement/update`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得专家成果分页
 */
export async function getExpertAchievementPage(params) {
  try {
    const data = await http.get(`${BASE_NAME}/expert/achievement/page`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得专家成果
 */
export async function getExpertAchievement(params) {
  try {
    const data = await http.get(`${BASE_NAME}/expert/achievement/get`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 上下架专家成果
 */
export async function updateExpertAchievementStatus(value) {
  try {
    const data = await http.put(`${BASE_NAME}/expert/achievement/publish`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 删除专家成果
 */
export async function deleteExpertAchievement(params) {
  try {
    const data = await http.delete(`${BASE_NAME}/expert/achievement/delete`, { params });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 创建专家荣誉
 */
export async function createExpertHonor(value) {
  try {
    const data = await http.post(`${BASE_NAME}/expert/honor/create`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 更新专家荣誉
 */
export async function updataExpertHonor(value) {
  try {
    const data = await http.put(`${BASE_NAME}/expert/honor/update`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得专家荣誉分页
 */
export async function getExpertHonorPage(params) {
  try {
    const data = await http.get(`${BASE_NAME}/expert/honor/page`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得专家荣誉
 */
export async function getExpertHonor(params) {
  try {
    const data = await http.get(`${BASE_NAME}/expert/honor/get`, {
      params,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 上下架专家荣誉
 */
export async function updateExpertHonorStatus(value) {
  try {
    const data = await http.put(`${BASE_NAME}/expert/honor/publish`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 删除专家荣誉
 */
export async function deleteExpertHonor(params) {
  try {
    const data = await http.delete(`${BASE_NAME}/expert/honor/delete`, { params });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得专家荣誉列表(已上架)
 */
export async function getExpertHonorList(params) {
  try {
    const data = await http.get(`${BASE_NAME}/expert/honor/list`, { params });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 关注（取消关注）
 */
export async function updateExpertLike(values) {
  try {
    const data = await http.post(`${BASE_NAME}/expert/like/update`, values);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得专家关注列表
 */
export async function getExpertLikeList(params) {
  try {
    const data = await http.get(`${BASE_NAME}/expert/like/list`, { params });

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 获得专家详情
 */
export async function getExpertDetail(params) {
  try {
    const data = await http.get(`${BASE_NAME}/expert/detail`, { params });

    return data;
  } catch (error) {
    console.error(error);
  }
}
